<template>
    <div v-loading="loading" class="common-scroll">
        <template v-if="!loading">
            <h3 class="title">时间段查询</h3>
            <div class="timeBlock">
                <div class="timeBlock-left">
                    <p>
                        <span style="display:inline-block;width: 6em">JPB仓时间：</span>
                        <el-date-picker
                                v-model="jpbChipTime"
                                @change="getTimeChipDetail('jpbChipView',$event)"
                                type="daterange"
                                value-format="yyyy-MM-dd"
                                range-separator="-"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"/>
                    </p>
                    <p style="margin-top: 10px;">
                        <span style="display:inline-block;width: 6em">系统仓时间：</span>
                        <el-date-picker
                                v-model="systemChipTime"
                                @change="getTimeChipDetail('systemChipView',$event)"
                                type="daterange"
                                value-format="yyyy-MM-dd"
                                range-separator="-"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"/>
                    </p>
                </div>
                <div class="timeBlock-right">
                    <div class="block-item">
                        <p class="block-text1">JPB仓</p>
                        <p class="block-text2" v-text="numberChip(jpbChipCompareChip)"></p>
                    </div>
                    <div class="block-item">
                        <p class="block-text1">系统仓</p>
                        <p class="block-text2" v-text="numberChip(systemChipCompareChip)">0</p>
                    </div>
                </div>
            </div>
            <h3 class="title" style="padding-top: 20px">金豆数据展示</h3>
            <div class="block" v-loading="loading_block">
                <div class="block-header">
                    <div class="common-search">
                        <el-date-picker
                                class="date"
                                size="small"
                                v-model="blockDate"
                                value-format="yyyy-MM-dd"
                                :picker-options="pickerOptions"
                                @change="getChipViewsDetail()"
                                type="date"/>
                        <el-button
                                type="primary"
                                plain
                                size="small"
                                @click="getNowChipViewsDetail">当前时间
                        </el-button>
                    </div>
                    <div class="block-header-item">
                        <p class="block-text1">中央仓</p>
                        <p class="block-text2">
                            <span v-text="`${numberChip(chipViewsDetail.center.totalChip)}`"></span>
                            <span :class="chipViewsDetail.center.compareWithLastDay>0?'up':'down'">
                                    <i class=" el-icon-back"></i>
                                    <span v-text="`(${numberChip(chipViewsDetail.center.compareWithLastDay)})`"></span>
                                </span>
                        </p>
                    </div>
                    <div class="block-header-item">
                        <p class="block-text1">累计差值（中央仓减其他）</p>
                        <p class="block-text2">
                            <span v-text="`(${numberChip(accumulatedNum)})`"></span>
                        </p>
                    </div>
                    <div class="block-header-item">
                        <p class="block-text1">新增差值</p>
                        <p class="block-text2">
                            <span v-text="`(${numberChip(newlly)})`"></span>
                        </p>
                    </div>
                </div>
                <div class="block-child">
                    <div class="block-left">
                        <div>
                            <!--<router-link :to="{name:'userChipView'}">
                                <el-button
                                        class="block-left-btn"
                                        type="primary"
                                        plain
                                        size="small">查看详情
                                </el-button>
                            </router-link>-->
                            <p class="block-text1">用户仓</p>
                            <p class="block-text2">
                                <span v-text="`${numberChip(chipViewsDetail.user.totalChip)}`"></span>
                                <span :class="chipViewsDetail.user.compareWithLastDay>0?'up':'down'">
                                    <i class="el-icon-back"></i>
                                    <span v-text="`(${numberChip(chipViewsDetail.user.compareWithLastDay)})`"></span>
                                </span>
                            </p>
                        </div>
                        <div class="block-child">
                            <div class="block-left-item">
                                <p class="block-text1">可提金豆</p>
                                <p class="block-text2" v-text="`${numberChip(chipViewsDetail.user.extractChip)}`"></p>
                            </div>
                            <div class="block-left-item">
                                <p class="block-text1">锁定金豆</p>
                                <p class="block-text2" v-text="`${numberChip(chipViewsDetail.user.lockChip)}`"></p>
                            </div>
                            <div class="block-left-item">
                                <p class="block-text1">不可提金豆</p>
                                <p class="block-text2" v-text="`${numberChip(chipViewsDetail.user.notExtractChip)}`"></p>
                            </div>
                        </div>
                    </div>
                    <div class="block-right">
                        <div>
                            <p class="block-text1">代充渠道仓</p>
                            <p class="block-text2">
                                <span v-text="`${numberChip(chipViewsDetail.payChannel.totalChip)}`"></span>
                                <span :class="chipViewsDetail.payChannel.compareWithLastDay>0?'up':'down'">
                                    <i class=" el-icon-back"></i>
                                    <span v-text="`(${numberChip(chipViewsDetail.payChannel.compareWithLastDay)})`"></span>
                                </span>
                            </p>
                        </div>
                        <div class="block-child">
                            <div class="block-left-item">
                                <p class="block-text1">锁定金豆</p>
                                <p class="block-text2" v-text="`${numberChip(chipViewsDetail.payChannel.lockChip)}`"></p>
                            </div>
                            <div class="block-left-item">
                                <p class="block-text1">未锁定金豆</p>
                                <p class="block-text2" v-text="`${numberChip(chipViewsDetail.payChannel.unlockChip)}`"></p>
                            </div>
                        </div>
                    </div>
                    <div style="flex: 1">
                        <div class="block-item">
                            <p class="block-text1">牌局仓</p>
                            <p class="block-text2">
                                <span v-text="`${numberChip(chipViewsDetail.roomChip.totalChip)}`"></span>
                                <span :class="chipViewsDetail.roomChip.compareWithLastDay>0?'up':'down'">
                                    <i class=" el-icon-back"></i>
                                    <span v-text="`(${numberChip(chipViewsDetail.roomChip.compareWithLastDay)})`"></span>
                                </span>
                            </p>
                        </div>

                        <div class="block-item">
                            <p class="block-text1">奖池仓</p>
                            <p class="block-text2">
                                <span v-text="`${numberChip(chipViewsDetail.prizePoolChip.totalChip)}`"></span>
                                <span :class="chipViewsDetail.prizePoolChip.compareWithLastDay>0?'up':'down'">
                                    <i class=" el-icon-back"></i>
                                    <span v-text="`(${numberChip(chipViewsDetail.prizePoolChip.compareWithLastDay)})`"></span>
                                </span>
                            </p>
                        </div>
                    </div>
                    <div class="block-bottom">
                        <div class="block-item">
                            <p class="block-text1">基金仓</p>
                            <p class="block-text2">
                                <span v-text="`${numberChip(chipViewsDetail.fund.totalChip)}`"></span>
                                <span :class="chipViewsDetail.fund.compareWithLastDay>0?'up':'down'">
                                    <i class=" el-icon-back"></i>
                                    <span v-text="`(${numberChip(chipViewsDetail.fund.compareWithLastDay)})`"></span>
                                </span>
                            </p>
                        </div>
                        <div class="block-item">
                            <p class="block-text1">营销账户仓</p>
                            <p class="block-text2">
                                <span v-text="`${numberChip(chipViewsDetail.market.totalChip)}`"></span>
                                <span :class="chipViewsDetail.market.compareWithLastDay>0?'up':'down'">
                                    <i class=" el-icon-back"></i>
                                    <span v-text="`(${numberChip(chipViewsDetail.market.compareWithLastDay)})`"></span>
                                </span>
                            </p>
                        </div>
                        <div class="block-item">
                            <p class="block-text1">JPB仓</p>
                            <p class="block-text2">
                                <span v-text="`${numberChip(chipViewsDetail.jpb.totalChip)}`"></span>
                                <span :class="chipViewsDetail.jpb.compareWithLastDay>0?'up':'down'">
                                    <i class=" el-icon-back"></i>
                                    <span v-text="`(${numberChip(chipViewsDetail.jpb.compareWithLastDay)})`"></span>
                                </span>
                            </p>
                        </div>
                        <div class="block-item">
                            <p class="block-text1">彩池仓</p>
                            <p class="block-text2">
                                <span v-text="`${numberChip(chipViewsDetail.jackpot.totalChip)}`"></span>
                                <span :class="chipViewsDetail.jackpot.compareWithLastDay>0?'up':'down'">
                                    <i class=" el-icon-back"></i>
                                    <span v-text="`(${numberChip(chipViewsDetail.jackpot.compareWithLastDay)})`"></span>
                                </span>
                            </p>
                        </div>
                        <div class="block-item">
                            <p class="block-text1">系统仓</p>
                            <p class="block-text2">
                                <span v-text="`${numberChip(chipViewsDetail.system.totalChip)}`"></span>
                                <span :class="chipViewsDetail.system.compareWithLastDay>0?'up':'down'">
                                    <i class=" el-icon-back"></i>
                                    <span v-text="`(${numberChip(chipViewsDetail.system.compareWithLastDay)})`"></span>
                                </span>
                            </p>
                        </div>
                        <div class="block-item">
                            <p class="block-text1">手工充值仓</p>
                            <p class="block-text2">
                                <span v-text="`${numberChip(chipViewsDetail.manualRecharge.totalChip)}`"></span>
                                <span :class="chipViewsDetail.manualRecharge.compareWithLastDay>0?'up':'down'">
                                    <i class=" el-icon-back"></i>
                                    <span v-text="`(${numberChip(chipViewsDetail.manualRecharge.compareWithLastDay)})`"></span>
                                </span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="chart">
                <div class="chart-left">
                    <h3 class="title">金豆分布图
                        <el-date-picker
                                size="small"
                                class="common-search date"
                                v-model="ringChartDate"
                                value-format="yyyy-MM-dd"
                                :picker-options="pickerOptions"
                                @change="getChipDistributions()"
                                type="date"/>
                    </h3>
                    <div class="chart-left-center">
                        <h3 v-text="`${numberChip(ringChartCenter)}`"></h3>
                        <p>中央仓</p>
                        <p>（100%）</p>
                    </div>
                    <ve-ring :data="ringChartData" :settings="ringChartSettings"/>
                </div>
                <div class="chart-right">
                    <ve-line :data="lineChartData" :settings="lineChartSettings"/>
                </div>
            </div>
        </template>
    </div>
</template>
<script>
    import {mapActions} from 'vuex'

    export default {
        data() {
            this.ringChartSettings = {
                legendLimit: 0
            };
            this.lineChartSettings = {};

            return {
                loading: true,
                loading_block: false,
                jpbChipTime: null,
                jpbChipCompareChip: 0,
                systemChipTime: null,
                systemChipCompareChip: 0,
                blockDate: '',
                chipViewsDetail: {},
                ringChartDate: '',
                pickerOptions: {},
                ringChartCenter: 0,
                ringChartData: {
                    columns: ['仓', '金豆'],
                    rows: []
                },
                lineChartData: {
                    columns: ['时间', '中央仓', '基金仓', '彩池仓', 'JPB仓', '营销账户仓', '代充渠道仓', '系统仓', '用户仓', '手工充值仓'],
                    rows: []
                }
            }
        },
        computed: {
            //累计差值
            accumulatedNum() {
                return this.chipViewsDetail.center.totalChip - (this.chipViewsDetail.user.totalChip + this.chipViewsDetail.fund.totalChip + this.chipViewsDetail.market.totalChip + this.chipViewsDetail.jpb.totalChip + this.chipViewsDetail.jackpot.totalChip + this.chipViewsDetail.payChannel.totalChip + this.chipViewsDetail.system.totalChip + this.chipViewsDetail.manualRecharge.totalChip + this.chipViewsDetail.roomChip.totalChip + this.chipViewsDetail.prizePoolChip.totalChip);
            },
            //新增差值
            newlly() {
                return this.chipViewsDetail.center.compareWithLastDay - (this.chipViewsDetail.user.compareWithLastDay + this.chipViewsDetail.fund.compareWithLastDay + this.chipViewsDetail.market.compareWithLastDay + this.chipViewsDetail.jpb.compareWithLastDay + this.chipViewsDetail.jackpot.compareWithLastDay + this.chipViewsDetail.payChannel.compareWithLastDay + this.chipViewsDetail.system.compareWithLastDay + this.chipViewsDetail.manualRecharge.compareWithLastDay + this.chipViewsDetail.roomChip.compareWithLastDay + this.chipViewsDetail.prizePoolChip.compareWithLastDay);
            }
        },
        created() {
            this.getChipViewsDetail(() => {
                this.loading = false;
            });
            this.getChipDistributions();
            this.getChipGraphs();
            this.getEndDate()
        },
        methods: {
            ...mapActions('warehouseAcquisitions', ['chipViews', 'nowChipViews', 'chipDistributions', 'chipGraphs', 'recentViewDate', 'getJpbChipView', 'getSystemChipView']),
            getTimeChipDetail(name, date) {
                if (name === 'jpbChipView') {
                    if (!date) {
                        this.jpbChipCompareChip = 0;
                        return
                    }
                    this.getJpbChipView({
                        startTime: date[0],
                        endTime: date[1],
                    }).then(res => {
                        this.jpbChipCompareChip = res.data.compareChip
                    });
                } else if (name === 'systemChipView') {
                    if (!date) {
                        this.systemChipCompareChip = 0;
                        return
                    }
                    this.getSystemChipView({
                        startTime: date[0],
                        endTime: date[1],
                    }).then(res => {
                        this.systemChipCompareChip = res.data.compareChip
                    });
                }
            },
          numberChip(val){
            return val/100;
          },
            getChipViewsDetail(callback) {
                this.chipViews(this.blockDate).then(res => {
                    callback && callback();
                    this.chipViewsDetail = res.data;
                    this.blockDate = res.data.viewDate;
                })
            },
            // 金豆数据当前时间数据
            getNowChipViewsDetail() {
                this.loading_block = true;
                this.nowChipViews().then(res => {
                    this.chipViewsDetail = res.data;
                    this.blockDate = '';
                    this.loading_block = false;
                })
            },
            getChipDistributions() {
                this.chipDistributions(this.ringChartDate).then(res => {
                    this.ringChartDate = res.data.viewDate;
                    this.ringChartCenter = res.data.centerChip;
                    this.ringChartData = Object.assign({}, this.ringChartData, {
                        rows: [
                            {'仓': '代充渠道仓', '金豆': this.numberChip(res.data.payChannel.totalChip)},
                            {'仓': '系统仓', '金豆': this.numberChip(res.data.system.totalChip)},
                            {'仓': '用户仓', '金豆': this.numberChip(res.data.user.totalChip)},
                            {'仓': '营销账户仓', '金豆': this.numberChip(res.data.market.totalChip)},
                            {'仓': '基金仓', '金豆': this.numberChip(res.data.fund.totalChip)},
                            {'仓': 'JPB仓', '金豆': this.numberChip(res.data.jpb.totalChip)},
                            {'仓': '彩池仓', '金豆': this.numberChip(res.data.jackpot.totalChip)},
                            {'仓': '手工充值仓', '金豆': this.numberChip(res.data.manualRecharge.totalChip)},
                            {'仓': '牌局仓', '金豆': this.numberChip(res.data.roomChip.totalChip)},
                            {'仓': '奖池仓', '金豆': this.numberChip(res.data.prizePoolChip.totalChip)}
                        ]
                    })
                })
            },
            getChipGraphs() {
                this.chipGraphs().then(res => {
                    let data = res.data;
                    let rows = [];
                    for (let i = 0; i < 7; i++) {
                        rows[i] = {
                            '时间': data.dates[i],
                            '中央仓': this.numberChip(data.center[i]),
                            '基金仓': this.numberChip(data.fund[i]),
                            '彩池仓': this.numberChip(data.jackpot[i]),
                            'JPB仓': this.numberChip(data.jpb[i]),
                            '营销账户仓': this.numberChip(data.market[i]),
                            '代充渠道仓': this.numberChip(data.payChannel[i]),
                            '系统仓': this.numberChip(data.system[i]),
                            '用户仓': this.numberChip(data.user[i]),
                            '手工充值仓': this.numberChip(data.manualRecharge[i])
                        }
                    }
                    this.lineChartData = Object.assign({}, this.lineChartData, {
                        rows: rows
                    })
                })
            },
            getEndDate() {
                this.recentViewDate().then(res => {
                    this.pickerOptions.disabledDate = (time) => {
                        return time.getTime() > new Date(res.data);
                    }
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    .date {
        width: 150px !important;
        vertical-align: middle;
    }

    .title {
        padding-left: 10px;
        padding-bottom: 5px;
    }

    .timeBlock {
        display: flex;
        align-items: center;
        padding: 20px;
        border-radius: 5px;
        border: 1px solid #eee;
        box-shadow: $box-shadow;
        &-right {
            flex: 1;
            max-width: 600px;
            display: flex;
            padding-left: 20px;
        }
    }

    .block {
        padding: 20px;
        border-radius: 5px;
        border: 1px solid #eee;
        box-shadow: $box-shadow;
        .up, .down {
            display: inline-block;
            vertical-align: middle;
            font-size: 14px;
        }

        .up {
            color: $green;
            .el-icon-back {
                font-weight: bold;
                transform: rotate(90deg);
            }
        }

        .down {
            color: red;
            .el-icon-back {
                font-weight: bold;
                transform: rotate(-90deg);
            }
        }

        &-header {
            padding-bottom: 10px;
            &-item {
                display: inline-block;
                margin-right: 20px;
            }
        }
        &-child {
            display: flex;
            flex-wrap: wrap;
        }
        &-left, &-right {
            display: flex;
            flex-flow: column;
            justify-content: center;
            text-align: center;
            border: 1px solid rgba($theme-color, .3);
            &-item {
                flex: 1;
                padding: 0 5px;
                margin-top: 20px;
                &:not(:first-of-type) {
                    border-left: 2px solid rgba($theme-color, .3);
                }
            }
        }
        &-left {
            position: relative;
            flex: 3;
            &-btn {
                position: absolute;
                top: 10px;
                right: 10px;
            }
        }
        &-right {
            flex: 2;
        }

        &-bottom {
            width: 100%;
            display: flex;
            align-items: stretch;
        }
        &-item {
            flex: 1;
            display: flex;
            flex-flow: column;
            justify-content: center;
            padding: 20px 5px;
            text-align: center;
            border: 1px solid rgba($theme-color, .3);
        }
        &-text1 {
            font-size: 16px;
        }
        &-text2 {
            padding-top: 5px;
            font-size: 20px;
            font-weight: bold;
            line-height: 1;
            word-break: break-all;
        }
    }

    .chart {
        flex: 1;
        display: flex;
        align-items: stretch;
        margin-top: 20px;
        &-left {
            position: relative;
            flex: 2;
            padding-top: 10px;
            margin-right: 20px;
            border-radius: 5px;
            border: 1px solid #eee;
            box-shadow: $box-shadow;
            .date {
                margin-right: 10px;
            }
            &-center {
                position: absolute;
                top: 240px;
                left: 50%;
                z-index: 1;
                text-align: center;
                transform: translate(-50%, -50%);
            }
        }
        &-right {
            flex: 3;
            padding-top: 40px;
            border-radius: 5px;
            border: 1px solid #eee;
            box-shadow: $box-shadow;
        }
    }
</style>